import React from 'react'
import { Create, required, SimpleForm, TextInput } from 'react-admin'

const PocCreate: React.FC = () => {
  return (
    <Create>
      <SimpleForm>
        <TextInput source="title" validate={[required()]} fullWidth />
      </SimpleForm>
    </Create>
  )
}

export default PocCreate
